module.exports = __webpack_public_path__ + "img/SKWINKELNetActieDeelnemenA1BD39.f255eba0.png";